import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";
import { Plugin } from "types/generated";

const PluginsTableSpaceCell = ({ item: plugin, ...cellProps }: TableSimpleCellProps<Plugin>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={plugin.spaceDetails.id} fallbackName={plugin.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default PluginsTableSpaceCell;
